<template>
  <div>
    <el-container>
      <el-main style="padding: 15px 20px 15px;">
        <!-- 搜索区域 -->
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" size="mini">
            <el-form-item label="产品编码:">
              <el-input v-model.trim="searchForm.productCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品名称:">
              <el-input v-model.trim="searchForm.productName" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="店铺名称:">
              <el-select v-model="searchForm.storeId" placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in storeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预估情况:">
              <el-select v-model="searchForm.status" placeholder="请选择" clearable multiple collapse-tags>
                <el-option label="超卖" value="超卖"></el-option>
                <el-option label="正常" value="正常"></el-option>
                <el-option label="滞销" value="滞销"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上市清单名称:">
              <el-select v-model="searchForm.listNo" placeholder="请选择" clearable filterable multiple collapse-tags>
                <el-option
                  v-for="item in listNoOptions"
                  :key="item.listNo"
                  :label="item.name"
                  :value="item.listNo"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="handleReset">重置</el-button>
            <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
          </template>
        </search-box>
      </el-main>
    </el-container>
    <el-container>
      <el-main style="padding: 0 20px 10px 20px">
        <el-table
          border
          :data="tableData"
          :height="tableHeight + 'px'"
          v-loading="loading"
          v-if="tableHeight"
        >
          <el-table-column label="图片" width="50px" fixed="left">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" v-if="scope.row.imgUrlList && scope.row.imgUrlList.length" @click="showPicture(scope.row)">查看</el-link>
              <el-link :underline="false" disabled v-else>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column label="产品编码" prop="productCode" width="150px" fixed="left" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="产品名称" prop="productName" min-width="180px" fixed="left" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="上市时间" prop="marketOn" width="120px"></el-table-column>
          <el-table-column label="新品首批量" prop="firstBatch" width="120px" align="center">
            <template #header>
              <span>新品首批量</span>
              <el-tooltip effect="dark" content="全网合计数量，未细分到店铺；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="直播销量" prop="planLiveSalesResult" width="90px" align="center"></el-table-column>
          <el-table-column label="实际销量" prop="salesResult" width="110px" align="center">
            <template #header>
              <span>实际销量</span>
              <el-tooltip effect="dark" content="不含非销和退款，包含直播销量；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showSalesDetail(scope.row)">{{ scope.row.salesResult }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="上市30日销量" prop="thirtyDaySale" width="130px" align="center">
            <template #header>
              <span>上市30日销量</span>
              <el-tooltip effect="dark" content="即从上市时间往后推算30天，此时的实际销量，后续不再变化；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="上市60日销量" prop="sixtyDaySale" width="130px" align="center">
            <template #header>
              <span>上市60日销量</span>
              <el-tooltip effect="dark" content="即从上市时间往后推算60天，此时的实际销量，后续不再变化；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="上市90日销量" prop="ninetyDaySale" width="130px" align="center">
            <template #header>
              <span>上市90日销量</span>
              <el-tooltip effect="dark" content="即从上市时间往后推算90天，此时的实际销量，后续不再变化；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="备货余量" prop="stockReserve" width="110px" align="center">
            <template #header>
              <span>备货余量</span>
              <el-tooltip effect="dark" content="根据新计划系统中计算的包件库存“净总量”拆分到产品而来；" placement="top">
                <i class="el-icon-question tipsIcon"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="预估差额" prop="diffAmount" width="90px" align="center"></el-table-column>
          <!-- <el-table-column label="预估差异率" prop="diffRate" width="100px" align="center"></el-table-column> -->
          <el-table-column label="预估情况" prop="status" width="90px" align="center"></el-table-column>
        </el-table>

        <!-- pagination -->
        <div style="overflow: hidden">
          <el-pagination
            style="float: right; margin-top: 10px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>

        <!-- 图片预览弹窗 -->
        <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close>
          <imgShow :imgList="imgList"></imgShow>
        </el-dialog>
        <sales-detail-dialog :visible.sync="salesDetailVisible" :code="currentSalesCode" :row-data="currentSalesRow" :form="form" type="product" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import imgShow from "@/views/components/imgShow";
import SalesDetailDialog from '../sales-detail-dialog.vue'

export default {
  name: 'product',
  components: { imgShow, SalesDetailDialog },
  props: ['form'],
  data() {
    return {
      loading: false,
      searchForm: {
        productCode: '',
        productName: '',
        status: [],
        listNo: []
      },
      storeOptions: [],
      listNoOptions: [],
      tableData: [],
      tableHeight: 0,
      // 图片弹窗
      imgFormVisible: false,
      imgList: [],
      salesDetailVisible: false,
      currentSalesCode: '',
      currentSalesRow: {},
      paginationOpt: {
        pageSizes: [50, 100, 200, 500],
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
    };
  },
  mounted() {
    this.getStoreOptions();
    this.getListNoOptions();
    this.addListener_refresh();
    this.init();
  },
  watch: {
    'form.planTime'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getListNoOptions();
      }
    }
  },
  methods: {
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', (_) => {
        this.tableHeight = 0;
        this.$nextTick((_) => {
          this.handleReset();
        });
      });
    },
    // 获取店铺列表
    async getStoreOptions() {
      try {
        let res = await this.$q.preSalePlan.planGetStoreNameOptions();
        if (res.success && res.data && res.data.storeNameOptions) {
          this.storeOptions = res.data.storeNameOptions;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getListNoOptions() {
      try {
        let res = await this.$q.preSalePlan.goodsQueryListNo({ fragment: [this.form.planTime] });
        if (res.success && res.data) {
          this.listNoOptions = res.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    init() {
      this.tableHeight = document.documentElement.clientHeight - 335;
      this.loading = true;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.form,
          ...this.searchForm,
          status: (this.searchForm.status || []).join(','),
          listNo: (this.searchForm.listNo || []),
        },
      };
      this.$q.preSalePlan.newProductResultListPage({ data }).then(res => {
        if (res.success) {
          this.tableData = res.data.records || [];
          this.paginationOpt.total = res.data.total || 0;
        } else {
          this.tableData = [];
          this.paginationOpt.total = 0;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleReset() {
      this.searchForm = {
        productCode: '',
        productName: '',
        status: [],
        listNo: []
      };
      this.paginationOpt.pageNum = 1;
      this.paginationOpt.pageSize = 50;
      this.init();
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // 导出
    async handleExport() {
      let data = {
        ...this.form,
        ...this.searchForm,
        status: (this.searchForm.status || []).join(','),
        listNo: (this.searchForm.listNo || []),
        pageSize: 10000,
        pageNum: 1,
      };
      let params = {
        appCode: 'ec-pc-new',
        paramMap: data,
        reportName: 'newPrePlanProductExport',
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 查看图片
    showPicture(row) {
      this.imgFormVisible = true;
      this.imgList = row.imgUrlList.map(v => v.path) || [];
    },
    showSalesDetail(row) {
      this.currentSalesCode = row.productCode;
      this.currentSalesRow = row;
      this.salesDetailVisible = true;
    },
    // 预估情况样式
    getStatusClass(status) {
      if (status === '超卖') return 'status-over';
      if (status === '滞销') return 'status-slow';
      return '';
    }
  },
};
</script>

<style lang="stylus" scoped>
.tipsIcon
  cursor pointer
  margin-left 4px
  color #909399

>>> .el-form--inline .el-form-item {
  margin-bottom: 0;
}

.status-over
  color #f56c6c

.status-slow
  color #e6a23c

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px;
}
</style>
